import { theme } from 'global/styles/theme'

// Implements the styled-system responsive array behaviour with JS.
// This is used to define response style js constants and apply them to react-spring
// objects.

export const detectBreakpoint = (width: number) => {
  const points = theme.breakpoints.map((br) => Number(br.replace('px', '')))
  return (
    points.findIndex((val, i) =>
      points[i + 1] ? width >= val && width < points[i + 1] : width >= val
    ) + 1
  )
}

export const getResponsiveVal = (vals: any[], breakIndex: number) => {
  if (!Array.isArray(vals)) {
    return vals
  }
  if (!vals[breakIndex]) {
    // Last index of a non-null element in an array from current breakpoint index
    let index = breakIndex
    while (index-- && !vals[index]);
    return vals[index]
  }
  return vals[breakIndex]
}

interface IResStyles {
  [key: string]: any | any[] | undefined
}
export const getResponsiveStyles = (
  styles: IResStyles = {},
  screenWidth?: number
) => {
  const out = {}
  const breakpoint = screenWidth ? detectBreakpoint(screenWidth) : 0
  Object.entries(styles).forEach(([key, value]) => {
    if (value) {
      out[key] = getResponsiveVal(value, breakpoint)
    }
  })
  return out
}
